import type { Audit } from '@cdab/scania/qpr/schema'
import type { AuditModelBase } from './base'
import { restoreDeviationDates } from './restoration.utils'
import type { AuditModelV5, AuditModelV5Data, DeviationModelV5 } from './v5'

export type DeviationModelV6 = DeviationModelV5 & {
  draft: boolean
}

export type AuditModelV6Data = Omit<AuditModelV5Data, 'deviations'> & {
  deviations: DeviationModelV6[]
}

export type AuditModelV6 = AuditModelBase<AuditModelV6Data, 6>

export function restoreAuditFromDataV6(audit: AuditModelV6) {
  restoreDeviationDates(audit.deviations)

  // FIXME: I believe the more correct approach would be to keep this "stateful" data uncached,
  // maybe in a different cache. But it works for now.
  audit.isGettingFiles = false

  return audit
}

export function createFromAuditV6(audit: Audit) {
  const auditModel: AuditModelV6 = {
    ...audit,
    auditPoints: audit.auditPoints.map(ap => ({
      ...ap,
      files: [],
      isGettingFiles: false
    })),
    deviations: audit.deviations.map(d => ({
      ...d,
      files: [],
      isGettingFiles: false,
      draft: d.draft ?? false
    })),
    pledges: audit.pledges.map(pl => ({
      ...pl,
      files: [],
      isGettingFiles: false
    })),
    files: [],
    isGettingFiles: false,
    VERSION: 6
  }
  return auditModel
}

export function migrateToV6(audit: AuditModelV5): AuditModelV6 {
  const auditModal: AuditModelV6 = Object.assign(audit, {
    ...audit,
    deviations: audit.deviations.map(d => ({
      ...d,
      draft: false
    })),
    VERSION: 6 as const
  })

  return auditModal
}
